export const YODA_API_END_POINT = 'https://yoda.netoxygen.ch/api/v1';
export const YODA_PUBLIC_END_POINT = 'https://yoda.netoxygen.ch/public';
export const CHANGELOG_FROM = '1.0.0';
export const CHANGELOG_RELEASE_LIMIT = 10;

export const changelogRequestUrls = (projectId, from, mergeIds) => {
    const merge = (mergeIds || []).filter(Boolean).join(',');
    let apiPath = `/projects/${projectId}/changelog/`;
    let publicPath = apiPath;
    if (from) {
        apiPath += from;
        publicPath += `from/${from}`;
    }
    if (merge) {
        apiPath += `/${merge}`;
        publicPath += `/merge/${merge}`;
    }
    return {
        apiPath,
        changelogUrl: `${YODA_PUBLIC_END_POINT}${publicPath}`,
    };
};

const notesOf = (change) => (
    change.release_notes && typeof change.release_notes === 'object'
        ? change.release_notes
        : {}
);

/**
 * Prefer public release_notes over the internal card title/description.
 * The Yoda changelog API embeds both; card fields are often technical briefs.
 */
export const presentChange = (change) => {
    const notes = notesOf(change);
    const title = notes.title || change.title;
    const description = notes.description || change.description;
    const image_field = change.imageUrl || change.image || notes.image || null;
    let imageUrl = null;
    if (image_field) {
        const as_string = String(image_field);
        imageUrl = as_string.startsWith('http')
            ? as_string
            : `${YODA_API_END_POINT}/changes/${change._id}/releaseImage`;
    }
    return {
        type: change.type,
        title,
        description,
        imageUrl,
    };
};

/**
 * Public Yoda changelog via fetch (plain objects for presentChange).
 * @netoxygen/yoda@1.4.0 hardens Change for missing release_notes, but we keep
 * raw JSON here so release_notes stay available for the UI without remapping.
 */
export const fetchYodaChangelog = async ({
    projectId,
    from = CHANGELOG_FROM,
    mergeIds = [],
    limit = CHANGELOG_RELEASE_LIMIT,
    timeoutMs = 20000,
} = {}) => {
    if (!projectId)
        throw new Error('Missing Yoda project id');

    const { apiPath, changelogUrl } = changelogRequestUrls(projectId, from, mergeIds);
    const params = new URLSearchParams();
    if (limit > 0)
        params.set('limit', String(limit));
    const url = `${YODA_API_END_POINT}${apiPath}${params.toString() ? `?${params}` : ''}`;

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok)
            throw new Error(response.statusText || `Changelog ${response.status}`);
        const data = await response.json();
        return {
            changelog: data.releases || [],
            upcoming: Array.isArray(data.upcoming) ? data.upcoming : [],
            changelogUrl,
        };
    } finally {
        clearTimeout(timer);
    }
};
